import { render, staticRenderFns } from "./TrendChip.vue?vue&type=template&id=ae200cb6&scoped=true"
import script from "./TrendChip.vue?vue&type=script&lang=js"
export * from "./TrendChip.vue?vue&type=script&lang=js"
import style0 from "./TrendChip.vue?vue&type=style&index=0&id=ae200cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae200cb6",
  null
  
)

export default component.exports